/** Страница входа: получает токен и открывает пользователю планировщик. */
import { useForm } from "@tanstack/react-form";
import { Link, useNavigate } from "react-router-dom";
import { z } from "zod";
import { apiHooks } from "@/api";
import { routerPaths } from "@/app/routerPaths";
import { UIKit } from "@/shared/ui";

const loginSchema = z.object({
	email: z
		.string()
		.min(1, "Введите электронную почту")
		.email("Введите корректную электронную почту"),
	password: z.string().min(1, "Введите пароль"),
});

export const LoginPage = () => {
	const navigate = useNavigate();
	const loginApi = apiHooks.auth.useLogin();
	const form = useForm({
		defaultValues: { email: "", password: "" },
		validators: { onChange: loginSchema },
		onSubmit: async ({ value }) => {
			const response = await loginApi.execute(value);
			if (response.error !== null) return;
			await navigate(routerPaths.planner);
		},
	});

	return (
		<div className="flex flex-1 items-center justify-center overflow-y-auto px-5 py-10">
			<form className="w-full max-w-sm" action={() => form.handleSubmit()}>
				<UIKit.Text className="mb-2 font-medium text-accent">GRID PLANNER</UIKit.Text>
				<UIKit.Text size="xl">Войти</UIKit.Text>
				<UIKit.Text className="mt-2 text-ink">Продолжите работу над своими проектами.</UIKit.Text>
				<div className="mt-7 space-y-4">
					<UIKit.FormField form={form} name="email">
						{(field) => (
							<UIKit.TextInput
								label="Электронная почта"
								type="email"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="email"
							/>
						)}
					</UIKit.FormField>
					<UIKit.FormField form={form} name="password">
						{(field) => (
							<UIKit.TextInput
								label="Пароль"
								type="password"
								value={field.state.value}
								onChange={field.handleChange}
								autoComplete="current-password"
							/>
						)}
					</UIKit.FormField>
				</div>
				<UIKit.Button
					className="mt-6 w-full border-accent bg-accent py-3 text-sm font-medium text-overlay-ink hover:border-accent-hover hover:bg-accent-hover"
					type="submit"
					disabled={loginApi.isPending}
				>
					{loginApi.isPending ? "Входим..." : "Войти"}
				</UIKit.Button>
				<UIKit.Text className="mt-5 text-center text-ink">
					Нет аккаунта?{" "}
					<Link className="font-medium text-accent hover:underline" to={routerPaths.register}>
						Зарегистрироваться
					</Link>
				</UIKit.Text>
				<UIKit.Text className="mt-3 text-center text-ink">
					<Link className="font-medium text-accent hover:underline" to={routerPaths.passwordReset}>
						Не помню пароль
					</Link>
				</UIKit.Text>
			</form>
		</div>
	);
};
